import {Component, Input, OnInit, ViewChild, ViewEncapsulation,} from '@angular/core';
import {Router} from '@angular/router';

export interface News {
    modDt: Date;
    hitCnt: number;
    writerNm: string;
    seqno: string;
    contEn: string;
    contKr: string;
    cdNmAr: string;
    cont2: string;
    moderId: string;
    title: string;
    cdNm: string;
    moderNm: string;
    regDt: Date;
    noticeClCd: string;
    ptNoticeOptId: number;
    cont1: string;
    cdNmFr: string;
    writerId: string;
}

@Component({
    selector: 'app-annonce-cards',
    templateUrl: './annonce-cards.component.html',
    styleUrls: ['./annonce-cards.component.css'],
    encapsulation: ViewEncapsulation.None,
})
export class AnnonceCardsComponent implements OnInit {
    @ViewChild('carousel', {static: false}) carousel: any;
    @Input() news: News[];
    responsiveOptions;

    constructor(private router: Router) {
        this.responsiveOptions = [
            {
                breakpoint: '1024px',
                numVisible: 1,
                numScroll: 1,
            },
            {
                breakpoint: '768px',
                numVisible: 1,
                numScroll: 1,
            },
            {
                breakpoint: '560px',
                numVisible: 1,
                numScroll: 1,
            },
        ];
    }

    next() {
        this.carousel.nextSlide();
    }

    prev() {
        this.carousel.previousSlide();
    }

    ngOnInit(): void {
    }

    voirannonces() {
        this.router.navigate(['/portail/administrator-announcements']);
    }
}
